/**
* @Author: Dmytro Mykhailov <dmitriymikhaylov>
* @Date:   2016-10-10T09:27:53+03:00
* @Email:  belindream@gmail.com
* @Project: Lumand
* @Last modified by:   dmitriymikhaylov
* @Last modified time: 2016-10-10T09:28:44+03:00
* @License: MIT
*/



import createReducer from 'utils/redux/createReducer'

const initialState = {
  active: true
}

export default createReducer(initialState, {
	LEASE_FILTER_SWITCH: (currentState, action) => (
		{
			active: !currentState.active
		}
	)
})



// WEBPACK FOOTER //
// ./src/reducers/leaseFilters.js